module.exports = __webpack_public_path__ + "static/img/29_pro.2889d28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/29_pro.jpg
// module id = mJrC
// module chunks = 0